import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayPointStuffEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/pointStuff/`
        this.webApi = new WebApi()
    }

    async getPointStuff (jsonArg) {
        const pointStuff = await this.webApi.post(`${this.url}getPointStuff`, jsonArg)
        if (pointStuff) {
            if (!pointStuff.status_code) {
                if (!pointStuff.error) {
                    return pointStuff
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${pointStuff.status_code}`)
            }
        }
        return null
    }

    async save (jsonArg) {
        const response = await this.webApi.post(`${this.url}savePointStuff`, jsonArg)
        if (!response.status_code) {
            return response
        } else {
            console.error(`Ошибка с кодом: ${response.status_code}`)
        }
    }
}
